import React from 'react';
// import { palette } from '@stats/playbook-components';
// import styled from 'styled-components';

export const ErrorPage: React.FC = () => {
  return <>
    <p>Unable to located requested items.</p>
  </>;
};
